import { useMemo } from "react"

interface Props {
  showTitle?: boolean
}

const TermsAndConds: React.FC<Props> = ({ showTitle = true }) => {
  const currentDate = useMemo(() => {
    const currrentMonthName = new Date().toLocaleString("default", { month: "long" })
    const currentDay = new Date().getDate()
    const currentYear = new Date().getFullYear()
    return `${currrentMonthName} ${currentDay}, ${currentYear}`
  }, [])
  return (
    <div className="space-y-4">
      {showTitle && <h1 className="text-2xl font-bold">🧾 TERMS AND CONDITIONS — T4Ever</h1>}
      <p className="text-sm">Last updated: {currentDate}</p>
      <p>
        Welcome to Legacy IA. By accessing and using our T4Ever software, you agree to comply with and be
        bound by the following Terms and Conditions. Please read them carefully before using our service.
      </p>
      <h4 className="font-bold">1. Acceptance of Terms</h4>
      <p>
        By accessing, registering for, or using T4Ever, you agree to these Terms and all applicable laws. If
        you do not agree, you must not use the service.
      </p>
      <h4 className="font-bold">2. Service Description</h4>
      <p>
        T4Ever is an artificial intelligence platform developed by Legacy IA, designed to offer automation,
        analysis, and support tools using AI models.
      </p>
      <h4 className="font-bold">3. Registration and Account</h4>
      <p>
        To access certain features, you must create an account by providing accurate and up-to-date
        information. You are responsible for maintaining the confidentiality of your credentials and for all
        activities that occur under your account.
      </p>
      <h4 className="font-bold">4. Permitted Use</h4>
      <p>
        You may only use T4Ever in accordance with the law and for legitimate purposes. You are prohibited
        from:
      </p>
      <ul className="ps-5 list-disc ms-5">
        <li>Attempting to gain unauthorized access to our systems or data.</li>
        <li>Using T4Ever to disseminate malicious, illegal, or harmful content.</li>
        <li>Copying, modifying, or redistributing portions of the software without permission.</li>
      </ul>
      <h4 className="font-bold">5. Intellectual Property</h4>
      <p>
        All intellectual property rights in the T4Ever software, the Legacy IA name, logos, interfaces, and
        content belong to Legacy IA or its licensors. No rights of use are granted beyond those expressly
        provided.
      </p>
      <h4 className="font-bold">6. Limitation of Liability</h4>
      <p>
        Legacy IA shall not be liable for direct or indirect damages arising from the use or inability to use
        the service. Use of T4Ever is at your own risk.
      </p>
      <h4 className="font-bold">7. Modifications</h4>
      <p>
        We may update these Terms at any time. Modifications will be effective upon posting on our website.
      </p>
      <h4 className="font-bold">8. Termination or Suspension</h4>
      <p>We may suspend or terminate your account if you violate these terms or misuse the platform.</p>
      <h4 className="font-bold">9. Applicable Law</h4>
      <p>
        These Terms are governed by the laws of the country where Legacy IA operates, without prejudice to any
        consumer rights established by local law.
      </p>
      <h4 className="font-bold">10. Contact</h4>
      <p>
        If you have any questions about these Terms, please contact us at: 📩 <b>support@example.com</b>
      </p>
    </div>
  )
}

export default TermsAndConds
